import * as React from 'react'
import styled from '../../utils/styled'
import sizeMe from 'react-sizeme';
import StackGrid from "react-stack-grid";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Moment from 'react-moment';
import { faBlackTie } from '@fortawesome/free-brands-svg-icons'
import { animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import { Waypoint } from 'react-waypoint';
import YoutubeBackground from 'react-youtube-background'

interface IndexGalleryProps {
  title: string,
  subtitle: string,
  category: string,
  loading: boolean,
  size: any,
  logo: string,
  data: any,
  history: any,
  fetchRequest: any
}

const IndexLayoutGallery: React.FunctionComponent<IndexGalleryProps> = ({  title, subtitle, loading, category, size, data, history, fetchRequest }) => {

 function toTop(event:any) {
    scroll.scrollTo(0, {smooth: true});
  }
  function handleEvent(event:any) {
    const  route = $(event.currentTarget).attr("to");
    alert(route);
    history.push(route);
  }
  function handleScroll(event:any) {
    // console.log("scrolling", scrollTo);
    // let y = $(event.currentTarget).offset().top-($(event.currentTarget).height()/2);
    // scroll
  }
  function scrollHandler(event:any) {

      if (!loading) {
        // console.log("loading", data[data.length-1])
        fetchRequest(data);
      }
  }
return (
  <Region>
       <HeadRegion>
         <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
     </HeadRegion>
     <StackGrid  duration={0}  style={{ margin: '5%' }}
      columnWidth={size.width<600 ? "100%" : "33%"}
    >
      {data!=undefined && data.length>=0 && data.map((Item,index) =>
      (<ImageLink  key={index} role="button"
      //onMouseEnter={handleScroll} onClick={handleEvent}
      href={`/${category}/${Item.url_name}`}
      colSpan={index%2==0 ? 1.5: (1.5)} columnWidth={index==0 ? "100%" : "30%"}>
        <Card>
          {fetchRequest && index==(data.length-1) && (<Waypoint onEnter={scrollHandler}></Waypoint>)}
          <Front>
            {Item.hasOwnProperty('cover')  && (
            <LazyLoadImage
    alt={Item.name}
    effect="blur"
    className="cover"
    height={'300px'}
    width={'100%'}
    src={ Item.hasOwnProperty('cover') ? (Item.cover['type'] === 'youtube' ?
    'https://img.youtube.com/vi/' + (Item.cover.url.indexOf('/') != -1  ? Item.cover.url.split('/')[Item.cover.url.split('/').length - 1] : Item.cover.url)+'/maxresdefault.jpg'
    : Item.cover.url) : '' }
     />)}
          <ImageInfo>
            <ImageLabel>{Item.name}</ImageLabel>
            { Item.hasOwnProperty('startDate') && (<ImageYear><Moment format="YYYY" date={Item.startDate}/></ImageYear>)}
            <ImageDescription>{Item.description}</ImageDescription>
          </ImageInfo>
          </Front>
          <Back><Icon key={index}
            background={ Item.hasOwnProperty('cover') ? Item.cover.url : 'none' }
          />
          <h1>{Item.name}</h1>
          {Item.description}</Back>
          </Card>
          </ImageLink>)}
    </StackGrid>
    <BackToTop onClick={toTop}>Back to top</BackToTop>
  </Region>
)}


export default IndexLayoutGallery;
const Region = styled('div')`
background-color: rgba(0,0,0,1);
height: 100vh;
`

const HeadRegion = styled('div')`
padding: 10% 0rem 2%  0rem;
margin: 0em;
color: white;
text-align: center;
`
const Title= styled('h1')`
margin: 0em;
font-size: 3.5rem;
font-weight: 200;
`
const Subtitle= styled('span')`
text-align: center;
font-size: 1.5rem;
font-weight: 300;
`
const BackToTop = styled('a')`
text-align: center;
font-size: 1rem;
font-weight: 300;
    cursor: pointer;
    text-align: center;
    width: 100%;
    display: block;
    padding: 1rem 0rem;
}
`
const ImageLink = styled('a')`
   pointer-events: auto;
  height: ${props => `${props.colSpan*200}px`};
  /* min-width: ${props => `${props.colSpan*300}px`}; */
  width: 100% ;
  overflow:hidden;
  /* min-height: 100px; */
  display: block;
  position: relative;
  z-index: 1;
  perspective: 1000;
  border:1px solid rgba(0,0,0,.2);
  cursor: pointer;
  &>div:first-child>div:first-child>div:first-child {

      transition: all 600ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
      transform:scale(1);
    }
  :hover>div:first-child>div:first-child>div:first-child {
      transform: scale(1.1);
    /* transform: rotateY(180deg); */
    /* box-shadow: -5px 5px 5px #aaa; */
  }
  :hover>div:first-child>div:first-child>div:last-child {
   //transform: translateY(-100%);
  //  bottom: 0px;
    background-color: rgba(0,0,0,.9);
    &>div {
     // color: rgba(255,255,255,1)
    }

  }
`
const Card = styled('div')`

  position:relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: all 600ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
  transition-delay: 300ms;

      border-radius: 10px;

    overflow: hidden;

`
const Front = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  transform: rotateY(0deg);

`
const Back = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: block;
  transform: rotateY(180deg);
  box-sizing: border-box;
  padding: 10px;
  color: white;
  text-align: center;
  background-color: #2C485A;
  font-size: 12px;
`

const Image = styled('div')`
  width: 100%;
  height: 100%;
  background-image: ${props => `url(${props.background})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: #1b1b1b;
`
const Youtube = styled('div')`
  width: 300px;
  height: 300px;
`
const Icon = styled('div')`
  width: 100px;
  height: 100px;
  display: block;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,1);
  margin: 20px auto;
  background-image: ${props => `url(${props.background})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`
const SymbolInfo = styled('div')`
  /* width: 100%; */
  position:absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align:center;
`
const Symbol = styled('div')`
  font-size: 8em;
  text-transform: uppercase;
  color: rgba(255,255,255,1);
  text-shadow: 1px 1px rgba(0,0,0,.5);
`
const SymbolDescription = styled('div')`
  font-size: 1.0em;
  text-transform: uppercase;
  color: rgba(255,255,255,1);
  text-shadow: 1px 1px rgba(0,0,0,.5);
    top: -3em;
    position: relative;
`

const ImageInfo = styled('div')`
  width: 100%;
  position:relative;
  bottom: 60px;
  min-height: 80px;
  background-color: rgba(0,0,0,1);
  padding: .5em .5em 1em .5em;
  color: rgba(0,0,0,1);

  transition: all 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
`
const ImageLabel = styled('div')`
  width: 100%;
  position:relative;
  text-transform: uppercase;
 font-weight: 300;
 color: #707070;
`

const ImageYear = styled('div')`
  width: 100%;
  position:relative;
  text-transform: uppercase;
  font-weight: 300;
 color: #D7D7D7;
`
const ImageDescription = styled('div')`
  width: 100%;
  position:relative;
  font-size: .8em;

`

const TableWrapper = styled('div')`
  position: relative;
  max-width: ${props => props.theme.widths.md};
  margin: 0 auto;
  min-height: 200px;
  display: inline-block;
`

const ItemDetail = styled('td')`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ItemIcon = styled('img')`
  width: 32px;
  height: 32px;
`

const ItemName = styled('div')`
  flex: 1 1 auto;
  height: 100%;
  margin-left: 1rem;

  a {
    color: ${props => props.theme.colors.brand};
  }
`

const ItemLoading = styled('tr')`
  td {
    height: 48px;
    text-align: center;
  }
`
